<script setup lang="ts">
import type { VueClass } from '@/kasten-components/types';
import { cnMerge } from '@/utils/utils.js';
import CloseIcon from '~icons/ion/close-outline';

import { badgeRemoveButtonVariants } from './badge-variants';
import type { KaBadgeColor } from './types';

export type KaBadgeRemoveProps = {
  label: string;
  color?: KaBadgeColor;
  class?: VueClass;
};

const props = withDefaults(defineProps<KaBadgeRemoveProps>(), {
  color: 'gray',
  class: '',
});

const emit = defineEmits<{
  (e: 'remove:click', event: MouseEvent): void;
  (e: 'remove:space', event: KeyboardEvent): void;
  (e: 'remove:enter', event: KeyboardEvent): void;
  (e: 'remove:focus', event: FocusEvent): void;
  (e: 'remove:blur', event: FocusEvent): void;
}>();
</script>
<template>
  <button
    :aria-label="`Remove ${props.label}`"
    type="button"
    :class="
      cnMerge(
        badgeRemoveButtonVariants({
          color: props.color,
        }),
        props.class,
      )
    "
    @click.stop="emit('remove:click', $event)"
    @keydown.space.stop="emit('remove:space', $event)"
    @keydown.enter.stop="emit('remove:enter', $event)"
    @focus="emit('remove:focus', $event)"
    @blur="emit('remove:blur', $event)"
  >
    <CloseIcon class="block h-3.5 w-3.5 p-0 [&>path]:!stroke-[9%]" />
  </button>
</template>
